var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopFiveNegativeSentiment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "91A84AD0-AD84-456C-9928-AF3AEF1F8D99") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-39.000000, -1875.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Chat/Summary-Metrics-Copy-2",
    transform: "translate(39.000000, 1875.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.000000, 60.052174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gold"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,15.8 C26,18.0106667 24.2106667,19.8 22,19.8 C19.792,19.8 18,18.0106667 18,15.8 C18,13.592 19.792,11.8 22,11.8 C24.2106667,11.8 26,13.592 26,15.8",
    id: "Fill-4",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,20.9304348 C44,23.1411014 42.2106667,24.9304348 40,24.9304348 C37.7893333,24.9304348 36,23.1411014 36,20.9304348 C36,18.7224348 37.7893333,16.9304348 40,16.9304348 C42.2106667,16.9304348 44,18.7224348 44,20.9304348",
    id: "Fill-7",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,41.4521739 C62,43.6628406 60.2106667,45.4521739 58,45.4521739 C55.7893333,45.4521739 54,43.6628406 54,41.4521739 C54,39.2441739 55.7893333,37.4521739 58,37.4521739 C60.2106667,37.4521739 62,39.2441739 62,41.4521739",
    id: "Fill-10",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,52.226087 C79,54.4367536 77.208,56.226087 75,56.226087 C72.7893333,56.226087 71,54.4367536 71,52.226087 C71,50.018087 72.7893333,48.226087 75,48.226087 C77.208,48.226087 79,50.018087 79,52.226087",
    id: "Fill-13",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,54.2782609 C97,56.4889275 95.208,58.2782609 93,58.2782609 C90.7893333,58.2782609 89,56.4889275 89,54.2782609 C89,52.0702609 90.7893333,50.2782609 93,50.2782609 C95.208,50.2782609 97,52.0702609 97,54.2782609",
    id: "Fill-16",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,54.2782609 C115,56.4889275 113.208,58.2782609 111,58.2782609 C108.789333,58.2782609 107,56.4889275 107,54.2782609 C107,52.0702609 108.789333,50.2782609 111,50.2782609 C113.208,50.2782609 115,52.0702609 115,54.2782609",
    id: "Fill-19",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,58.8956522 C132,61.1063188 130.210667,62.8956522 128,62.8956522 C125.792,62.8956522 124,61.1063188 124,58.8956522 C124,56.6876522 125.792,54.8956522 128,54.8956522 C130.210667,54.8956522 132,56.6876522 132,58.8956522",
    id: "Fill-22",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,54.2782609 C150,56.4889275 148.210667,58.2782609 146,58.2782609 C143.792,58.2782609 142,56.4889275 142,54.2782609 C142,52.0702609 143.792,50.2782609 146,50.2782609 C148.210667,50.2782609 150,52.0702609 150,54.2782609",
    id: "Fill-25",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,52.226087 C168,54.4367536 166.210667,56.226087 164,56.226087 C161.792,56.226087 160,54.4367536 160,52.226087 C160,50.018087 161.792,48.226087 164,48.226087 C166.210667,48.226087 168,50.018087 168,52.226087",
    id: "Fill-28",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,50.173913 C186,52.3845797 184.210667,54.173913 182,54.173913 C179.789333,54.173913 178,52.3845797 178,50.173913 C178,47.965913 179.789333,46.173913 182,46.173913 C184.210667,46.173913 186,47.965913 186,50.173913",
    id: "Fill-31",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,26.573913 C204,28.7845797 202.210667,30.573913 200,30.573913 C197.789333,30.573913 196,28.7845797 196,26.573913 C196,24.365913 197.789333,22.573913 200,22.573913 C202.210667,22.573913 204,24.365913 204,26.573913",
    id: "Fill-34",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,8.10434783 C221,10.3150145 219.208,12.1043478 217,12.1043478 C214.789333,12.1043478 213,10.3150145 213,8.10434783 C213,5.89634783 214.789333,4.10434783 217,4.10434783 C219.208,4.10434783 221,5.89634783 221,8.10434783",
    id: "Fill-37",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,4 C239,6.21066667 237.208,8 235,8 C232.789333,8 231,6.21066667 231,4 C231,1.792 232.789333,0 235,0 C237.208,0 239,1.792 239,4",
    id: "Fill-40",
    fill: "#892559"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#892559",
    strokeWidth: 2,
    fillRule: "nonzero",
    points: "4 6.06214343 21.6352442 15.590551 39.6857707 19.854084 58.0365625 41.2419619 75.8601087 52.389583 92.9426612 54.7152447 111.02983 54.7152447 128.059455 59.4086957 146.448925 54.7152447 164.609379 52.389583 182.173374 49.6275222 199.664083 26.2618058 218.109535 7.73104601 235.065874 3.48695652 253.206989 15.590551 271 19.854084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 2.012342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,37.5483871 C26,39.7590538 24.2106667,41.5483871 22,41.5483871 C19.7893333,41.5483871 18,39.7590538 18,37.5483871 C18,35.3403871 19.7893333,33.5483871 22,33.5483871 C24.2106667,33.5483871 26,35.3403871 26,37.5483871",
    id: "Fill-52",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,22.0645161 C43,24.2751828 41.2106667,26.0645161 39,26.0645161 C36.7893333,26.0645161 35,24.2751828 35,22.0645161 C35,19.8565161 36.7893333,18.0645161 39,18.0645161 C41.2106667,18.0645161 43,19.8565161 43,22.0645161",
    id: "Fill-55",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,24.6451613 C61,26.855828 59.208,28.6451613 57,28.6451613 C54.7893333,28.6451613 53,26.855828 53,24.6451613 C53,22.4371613 54.7893333,20.6451613 57,20.6451613 C59.208,20.6451613 61,22.4371613 61,24.6451613",
    id: "Fill-58",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,22.0645161 C78,24.2751828 76.208,26.0645161 74,26.0645161 C71.7893333,26.0645161 70,24.2751828 70,22.0645161 C70,19.8565161 71.7893333,18.0645161 74,18.0645161 C76.208,18.0645161 78,19.8565161 78,22.0645161",
    id: "Fill-61",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,24.6451613 C96,26.855828 94.208,28.6451613 92,28.6451613 C89.7893333,28.6451613 88,26.855828 88,24.6451613 C88,22.4371613 89.7893333,20.6451613 92,20.6451613 C94.208,20.6451613 96,22.4371613 96,24.6451613",
    id: "Fill-64",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,20 C115,22.2106667 113.210667,24 111,24 C108.792,24 107,22.2106667 107,20 C107,17.792 108.792,16 111,16 C113.210667,16 115,17.792 115,20",
    id: "Fill-67",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,16.9032258 C132,19.1138925 130.210667,20.9032258 128,20.9032258 C125.792,20.9032258 124,19.1138925 124,16.9032258 C124,14.6952258 125.792,12.9032258 128,12.9032258 C130.210667,12.9032258 132,14.6952258 132,16.9032258",
    id: "Fill-70",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,20 C150,22.2106667 148.210667,24 146,24 C143.792,24 142,22.2106667 142,20 C142,17.792 143.792,16 146,16 C148.210667,16 150,17.792 150,20",
    id: "Fill-73",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,14.3225806 C167,16.5332473 165.210667,18.3225806 163,18.3225806 C160.789333,18.3225806 159,16.5332473 159,14.3225806 C159,12.1145806 160.789333,10.3225806 163,10.3225806 C165.210667,10.3225806 167,12.1145806 167,14.3225806",
    id: "Fill-76",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,6.58064516 C185,8.79131183 183.210667,10.5806452 181,10.5806452 C178.789333,10.5806452 177,8.79131183 177,6.58064516 C177,4.37264516 178.789333,2.58064516 181,2.58064516 C183.210667,2.58064516 185,4.37264516 185,6.58064516",
    id: "Fill-79",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,4 C202,6.21066667 200.208,8 198,8 C195.789333,8 194,6.21066667 194,4 C194,1.792 195.789333,1.13686838e-13 198,1.13686838e-13 C200.208,1.13686838e-13 202,1.792 202,4",
    id: "Fill-82",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,6.58064516 C220,8.79131183 218.208,10.5806452 216,10.5806452 C213.789333,10.5806452 212,8.79131183 212,6.58064516 C212,4.37264516 213.789333,2.58064516 216,2.58064516 C218.208,2.58064516 220,4.37264516 220,6.58064516",
    id: "Fill-85",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,14.3225806 C239,16.5332473 237.208,18.3225806 235,18.3225806 C232.789333,18.3225806 231,16.5332473 231,14.3225806 C231,12.1145806 232.789333,10.3225806 235,10.3225806 C237.208,10.3225806 239,12.1145806 239,14.3225806",
    id: "Fill-88",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFBF00",
    strokeWidth: 2,
    fillRule: "nonzero",
    points: "4 47.3548387 21.4195814 37.9246988 39.450644 21.9101151 56.6606329 24.7871887 74.3976554 21.9101151 92.4287179 24.7871887 110.545245 19.4506033 128.675 17.4243421 145.927721 19.4506033 163.969975 14.6727783 181.46383 6.96236574 199.0228 4.51612903 216.966363 6.96236574 235.38914 14.6727783 253 19.4506033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(128.000000, 36.947826) scale(1, -1) translate(-128.000000, -36.947826) translate(0.000000, 23.034783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,19.6521739 C26,21.8628406 24.2106667,23.6521739 22,23.6521739 C19.7893333,23.6521739 18,21.8628406 18,19.6521739 C18,17.4441739 19.7893333,15.6521739 22,15.6521739 C24.2106667,15.6521739 26,17.4441739 26,19.6521739",
    id: "Fill-52",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,11.826087 C43,14.0367536 41.2106667,15.826087 39,15.826087 C36.7893333,15.826087 35,14.0367536 35,11.826087 C35,9.61808696 36.7893333,7.82608696 39,7.82608696 C41.2106667,7.82608696 43,9.61808696 43,11.826087",
    id: "Fill-55",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,12.8695652 C61,15.0802319 59.208,16.8695652 57,16.8695652 C54.7893333,16.8695652 53,15.0802319 53,12.8695652 C53,10.6615652 54.7893333,8.86956522 57,8.86956522 C59.208,8.86956522 61,10.6615652 61,12.8695652",
    id: "Fill-58",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,11.826087 C78,14.0367536 76.208,15.826087 74,15.826087 C71.7893333,15.826087 70,14.0367536 70,11.826087 C70,9.61808696 71.7893333,7.82608696 74,7.82608696 C76.208,7.82608696 78,9.61808696 78,11.826087",
    id: "Fill-61",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,12.8695652 C96,15.0802319 94.208,16.8695652 92,16.8695652 C89.7893333,16.8695652 88,15.0802319 88,12.8695652 C88,10.6615652 89.7893333,8.86956522 92,8.86956522 C94.208,8.86956522 96,10.6615652 96,12.8695652",
    id: "Fill-64",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,10.7826087 C115,12.9932754 113.210667,14.7826087 111,14.7826087 C108.792,14.7826087 107,12.9932754 107,10.7826087 C107,8.5746087 108.792,6.7826087 111,6.7826087 C113.210667,6.7826087 115,8.5746087 115,10.7826087",
    id: "Fill-67",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,9.73913043 C132,11.9497971 130.210667,13.7391304 128,13.7391304 C125.792,13.7391304 124,11.9497971 124,9.73913043 C124,7.53113043 125.792,5.73913043 128,5.73913043 C130.210667,5.73913043 132,7.53113043 132,9.73913043",
    id: "Fill-70",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,10.7826087 C150,12.9932754 148.210667,14.7826087 146,14.7826087 C143.792,14.7826087 142,12.9932754 142,10.7826087 C142,8.5746087 143.792,6.7826087 146,6.7826087 C148.210667,6.7826087 150,8.5746087 150,10.7826087",
    id: "Fill-73",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,8.69565217 C167,10.9063188 165.210667,12.6956522 163,12.6956522 C160.789333,12.6956522 159,10.9063188 159,8.69565217 C159,6.48765217 160.789333,4.69565217 163,4.69565217 C165.210667,4.69565217 167,6.48765217 167,8.69565217",
    id: "Fill-76",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,5.04347826 C185,7.25414493 183.210667,9.04347826 181,9.04347826 C178.789333,9.04347826 177,7.25414493 177,5.04347826 C177,2.83547826 178.789333,1.04347826 181,1.04347826 C183.210667,1.04347826 185,2.83547826 185,5.04347826",
    id: "Fill-79",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,4 C202,6.21066667 200.208,8 198,8 C195.789333,8 194,6.21066667 194,4 C194,1.792 195.789333,0 198,0 C200.208,0 202,1.792 202,4",
    id: "Fill-82",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,5.04347826 C220,7.25414493 218.208,9.04347826 216,9.04347826 C213.789333,9.04347826 212,7.25414493 212,5.04347826 C212,2.83547826 213.789333,1.04347826 216,1.04347826 C218.208,1.04347826 220,2.83547826 220,5.04347826",
    id: "Fill-85",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,8.69565217 C239,10.9063188 237.208,12.6956522 235,12.6956522 C232.789333,12.6956522 231,10.9063188 231,8.69565217 C231,6.48765217 232.789333,4.69565217 235,4.69565217 C237.208,4.69565217 239,6.48765217 239,8.69565217",
    id: "Fill-88",
    fill: "#F6533F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#F6533F",
    strokeWidth: 2,
    fillRule: "nonzero",
    points: "4 24.3478261 21.4195814 19.8686331 39.450644 12.2619156 56.6606329 13.6284879 74.3976554 12.2619156 92.4287179 13.6284879 110.545245 11.0936797 128.675 10.1312322 145.927721 11.0936797 163.969975 8.82427541 181.46383 5.1619304 199.0228 4 216.966363 5.1619304 235.38914 8.82427541 253 11.0936797"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    mask: "url(#mask-2)",
    x: 0,
    y: 123,
    width: 235,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 2,
    height: 125
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(84.000000, 5.000000)",
    fill: "#661C42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5,38.0999222 C29.2492222,38.0999222 25.6945,41.1558667 25.0431111,45.3694222 C24.8867778,46.3855889 25.5828333,47.3347556 26.599,47.4910889 C27.604,47.6399778 28.5643333,46.9513667 28.7206667,45.9352 C29.0891667,43.5529778 31.0991667,41.8221444 33.5,41.8221444 C35.9008333,41.8221444 37.9108333,43.5529778 38.2793333,45.9352 C38.4356667,46.9513667 39.3848333,47.6399778 40.401,47.4910889 C41.4171667,47.3347556 42.1132222,46.3855889 41.9568889,45.3694222 C41.3055,41.1558667 37.7507778,38.0999222 33.5,38.0999222",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6111111,26.0555556 C16.5564444,26.0555556 14.8888889,24.0008889 14.8888889,26.0555556 C14.8888889,28.1102222 16.5564444,29.7777778 18.6111111,29.7777778 C20.6657778,29.7777778 22.3333333,28.1102222 22.3333333,26.0555556 C22.3333333,24.0008889 20.6657778,26.0555556 18.6111111,26.0555556",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3888889,26.0555556 C46.3342222,26.0555556 44.6666667,24.0008889 44.6666667,26.0555556 C44.6666667,28.1102222 46.3342222,29.7777778 48.3888889,29.7777778 C50.4435556,29.7777778 52.1111111,28.1102222 52.1111111,26.0555556 C52.1111111,24.0008889 50.4435556,26.0555556 48.3888889,26.0555556",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5,63.2777778 C17.0812778,63.2777778 3.72222222,49.9187222 3.72222222,33.5 C3.72222222,17.0812778 17.0812778,3.72222222 33.5,3.72222222 C49.9187222,3.72222222 63.2777778,17.0812778 63.2777778,33.5 C63.2777778,49.9187222 49.9187222,63.2777778 33.5,63.2777778 M33.5,0 C14.9968333,0 0,14.9968333 0,33.5 C0,52.0031667 14.9968333,67 33.5,67 C52.0031667,67 67,52.0031667 67,33.5 C67,14.9968333 52.0031667,0 33.5,0",
    id: "Fill-7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFiveNegativeSentiment);
export default __webpack_public_path__ + "static/media/top-five-negative-sentiment.d3cc9626fd06d5cc4795df9e14ddfd54.svg";
export { ForwardRef as ReactComponent };